import { createElement } from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export const AverageIcon = (props: SvgIconProps) =>
  createElement(
    SvgIcon,
    props,
    <>
      <path d="M19 8.41L17.59 7L12 12.59L6.41 7L5 8.41L10.59 14L5 19.59L6.41 21L12 15.41L17.59 21L19 19.59L13.41 14L19 8.41Z" />
      <path d="M4 3L20 3L20 5L4 5L4 3Z" />
    </>,
  );
